export const fieldTypes = {
    humidity: "Влажность",
    temperature: "Температура",
}
export default fieldTypes;
